import { render, staticRenderFns } from "./DetailStock.vue?vue&type=template&id=4c6eada4"
import script from "./DetailStock.vue?vue&type=script&lang=js"
export * from "./DetailStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports